<template>
    <div class="cont-custom-image">
        <v-hover v-slot="{ hover }">
            <div>
                <v-icon v-if="showDownload" large @click="downloadImage()"
                    :class="['download-icon', { 'on-hover': hover }]">mdi-file-download</v-icon>
                <router-link v-if="linkTo" target="_blank" :to="linkTo">
                    <v-img contain :src="imagePath" :max-height="height" @error="onError"></v-img>
                </router-link>
                <v-img v-else contain :src="imagePath" :max-height="height" @error="onError"></v-img>
            </div>
        </v-hover>
    </div>
</template>
<style lang="scss" scoped>
.cont-custom-image {
    position: relative;
}

.v-icon {
    position: absolute;
    right: 7px;
    top: 7px;
    z-index: 2;
    transition: opacity 0.4s ease-in-out;
}

.v-icon:not(.on-hover) {
    opacity: .6;
}
</style>
<script>
export default {
    name: "productImage",
    props: {
        productId: {
            type: String,
            required: true,
        },
        height: {
            type: Number,
            default: null,
            required: false,
        },
        linkTo: {
            type: Object,
            default: null,
            require: false,
        },
        showDownload: {
            type: Boolean,
            default: true,
            require: false
        }
    },
    data: () => {
        return {
            error: false,
        };
    },
    computed: {
        imagePath() {
            if (!this.error) {
                let normId = this.productId.replace("/", "_") + ".jpg";
                return "/images/catalog/lower/" + normId;
            } else {
                return "no_image.jpg";
            }
        },
    },
    methods: {
        onError() {
            this.error = true;
        },
        downloadImage() {
            window.open(this.imagePath);
        },
    },
};
</script>
